import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames/bind'

import ListItem from './ListItem'

import s from './List.module.scss'
import HorizontalWapper from '../HorizontalWrapper'
const cn = classNames.bind(s)

const _ = {
  maxLength: 10,
}

const List = ({ data }) => {
  const { fields } = data

  return (
    <HorizontalWapper>
      <ul className={cn('list')}>
        {fields.slice(0, _.maxLength).map((field, i) => (
          <ListItem key={i} text={field.item} />
        ))}
      </ul>
    </HorizontalWapper>
  )
}

List.propTypes = {
  data: PropTypes.object,
}

export default List
